module.exports = __webpack_public_path__ + "static/media/convective-icon-high.a3f9ddd0.svg";